import { NetworkRequestState } from '../baseTypes';
import { GdprWidgetData, GdprWidgetStep } from './types';

export const defaultGdprWidgetState: GdprWidgetData = {
  step: GdprWidgetStep.Initial,
  isDeactivated: false,
  isPersonaldataRequestInitiated: false,
  isRemoveRequestInitiated: false,
  isRemoveRequestInProgress: false,
  isGdprLinkSent: false,
  networkRequests: {
    personalDataRequest: {
      status: NetworkRequestState.IDLE,
    },
    initiateRemoveDataRequest: {
      status: NetworkRequestState.IDLE,
    },
    confirmRemoveDataRequest: {
      status: NetworkRequestState.IDLE,
    },
    resendRemoveConfirmationRequest: {
      status: NetworkRequestState.IDLE,
    },
    resendDownloadLinkRequest: {
      status: NetworkRequestState.IDLE,
    },
  },
};
